import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';

/** availability is only returned when using the Find Times endpoint */
interface IAvatarContact {
    id?: string;
    name?: string;
    email?: string;
    userId?: string;
    availability?: 'suggested' | 'available' | 'collective-suggested';
    contactName?: string;
    contactEmails?: string[];
}

declare var $: any;
@Component({
    selector: 'zoom-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent implements OnInit {
    @Input() contact: IAvatarContact = { name: 'Unknown contact' };
    @Input() additionalContacts: IAvatarContact[] = null;
    @Input() size: 'small' | null = null;
    @Input() shouldShowPopup = true;
    @Input() shouldDisplayDynamicCopy = false;
    @ViewChild('popupActivator') popupActivator: ElementRef;
    public _contact: { name: string; email: string };
    public _additionalContacts: { name: string; email: string }[];
    public popupText = 'This time was selected by:';
    public isSuggestedTime = false;

    constructor() {}

    ngOnInit() {
        if (this.contact) {
            this._contact = this.transformContactIn(this.contact);
            if (
                this.shouldDisplayDynamicCopy &&
                (!this.contact.availability || this.contact.availability === 'available')
            ) {
                this.popupText = 'Available at this time:';
            }
        }

        if (this.additionalContacts) {
            this._additionalContacts = this.transformAdditionalContactsIn(this.additionalContacts);
            if (this.shouldDisplayDynamicCopy) {
                this.popupText = 'The following suggested or are available at this time:';
            }
        }
    }

    ngAfterViewInit() {
        if (this.shouldShowPopup) {
            $(this.popupActivator.nativeElement).popup({
                variation: 'very wide',
                inline: true,
                hoverable: true,
                closable: false
            });
        }
    }

    private transformContactIn(contact: IAvatarContact) {
        /**
         * name and email should exist on the meeting host (user)
         * contactName and/or contactEmail can be found on other contacts (invitees)
         * */
        const name = contact.contactName || contact.name || contact.email;
        const email = (contact.contactEmails && contact.contactEmails[0]) || contact.email;
        return {
            name,
            email
        };
    }

    private transformAdditionalContactsIn(contacts) {
        return contacts.map((contact) => {
            return this.transformContactIn(contact);
        });
    }
}
